import { Text } from "@acko-tech/building-blocks.ui.typography";
import styled from "styled-components";

export const NotSureHeading = styled(Text)`
  color: var(--Purple-P500, #451999);
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;

  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

export const NotSureContent = styled(Text)`
  color: var(--Neutral-N500, #36354C);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 20px;
  @media (min-width: 768px) {
    font-size: 14px;
    line-height: 20px;
  }
`;

export const NotSureContainer = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  border-radius: 12px;
  border: 1px solid var(--line-primary-n-200, #E7E7F0);
  background: var(--background-white-n-0, #FFF);
  box-shadow: 0 4px 6px -2px rgba(54, 53, 76, 0.08);
  padding: 16px;
`;

export const Price = styled(Text)`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
`;

export const PriceLabel = styled(Text)`
  color: var(--Neutral-N500, #36354C);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const StrikeThroughPrice = styled(Text)`
  color: var(--Text-Disabled-grey200, #A6A6A6);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: line-through;
`;

export const ExplorePlansButton = styled.button`
  display: flex;
  padding: 8px 16px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid #000;
  background: #fff;
  text-wrap: nowrap;
`;